import { getToken, isTokenExpired } from './authService';

// Optional browser evidence. The server fixes the tenant, actor, allowed actions and
// evidence type; these actions never count as verified server completions.
export function recordActivity(action) {
  try {
    const token = getToken();
    if (!token || isTokenExpired(token)) return;
    const request = fetch('/s1/engagement/activity', {
      method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ action }),
    });
    request.catch(() => {});
  } catch { /* Telemetry must not interrupt product actions. */ }
}
